// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_xBa","cls2":"SimplePaperPodcast-cls2_L2s SimplePaperPodcast-cls1_xBa"};